     <!-- Start Main Banner Area -->
     <div class="main-banner-area"  id="home">
        <div class="video-background-container">
            <!-- <video autoplay muted loop playsinline>
              <source src="https://executiveroundtable.org/wp-content/uploads/2023/08/BRoll-for-Website-Banner.m4v" type="video/mp4" />
              Your browser does not support the video tag.
            </video> -->
            
            <!-- <img src="assets/images/tab1-frame1.jpg"> -->
          
            <div class="content-overlay">
              <!-- Your foreground content goes here -->
              <div class="container">
                  <div class="row align-items-center">
                      <div class="col-lg-7 col-md-12">
                          <div class="main-banner-content">
                              <p class="sub-title wow fadeInUp" data-wow-delay="300ms" data-wow-duration="2000ms"><span>A Trusted Peer Network for Technology Executives</span></p>
                              <h1 class="wow fadeInUp" data-wow-delay="100ms" data-wow-duration="1000ms">
                                RoundtableCxO</h1>
                              <!-- <p class="wow fadeInUp" data-wow-delay="200ms" data-wow-duration="1500ms">Aenean sollicitudin lorem quis bibendum auctor, nisi elit consequat ipsum nec sagittis sem nibh id elit. duis sed odio sit amet nibh vulputate cursus.</p> -->
      
                              <!-- <div class="banner-btn wow fadeInUp" data-wow-delay="300ms" data-wow-duration="2000ms">
                                  <a href="pricing.html" class="default-btn"><i class='bx bx-calendar'></i> Upcoming Events<span></span></a>
      
                                   <a href="https://www.youtube.com/watch?v=ODfy2YIKS1M" class="optional-btn popup-youtube">
                                      <i class='bx bx-play'></i>
                                      Watch Presentation</a> 
                              </div> -->
                          </div>
                      </div>
      
                      <div class="col-lg-5 col-md-12">
                          <div class="main-banner-image wow fadeInUp" data-wow-delay="300ms" data-wow-duration="2000ms">
                              <!-- <img src="./assets/images/main-banner/banner-1.png" alt="image"> -->
                          </div>
                      </div>
                  </div>
              </div>
            </div>
        </div>
    </div>
    <!-- End Main Banner Area -->

    <app-missionandvision></app-missionandvision>
    <app-about-us></app-about-us>
    <!-- <app-services></app-services> -->
    <!-- <app-sponsors></app-sponsors> -->

       

<!-- <app-about-us id="about"></app-about-us>
<app-missionandvision id="mission"></app-missionandvision>
<app-services id="services"></app-services>
<app-sponsors id="sponsors"></app-sponsors>
<app-contact-us id="contact"></app-contact-us> -->
